import { render, staticRenderFns } from "./Col.vue?vue&type=template&id=99e2e3c6"
import script from "./Col.vue?vue&type=script&lang=js"
export * from "./Col.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports